// extracted by mini-css-extract-plugin
export default {"share_button_list__wrapper":"e357d8","share_button_list":"b6105d","share_button_list__title":"f9dcc8"};